import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import * as nieuweSportclubModelsActions from "../../../actions/nieuweSportclubModelsActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import redirector from "../../../util/redirector";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import ConfirmModal from "../../../components/common/ConfirmModal";

import AdresPageHelper from "./AdresPageHelper";
import AdresForm from "./AdresForm";
import mergeDeep from "../../../util/mergeDeep.js";

class AdresPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: {
                adressen: []
            },
            addMode: false,
            editingAdres: {},
            errors: {},
            landen: [],
            adresTypes: [],
            straten: [],
            huisnummers: null,
            busnummers: null,
            deletingAdresId: null,
            showUnknownToPartnerModal: false
        };

        this.pageHelper = new AdresPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    componentWillUnmount = () => {
        let model = mergeDeep({}, this.state.model);
        this.props.updateModel(model);
    };

    handleOnGoToNext = () => this.pageHelper.goToNext();
    handleOnGoToPrev = () => this.pageHelper.goToPrev();
    handleOnClickAdd = () => this.pageHelper.onClickAdd();
    handleOnCancelAdd = () => this.pageHelper.onCancelAdd();
    handleOnChange = (event) => this.pageHelper.onChange(event);
    handleOnSaveNewAdres = () => this.pageHelper.onSaveNewAdres();
    handleOnDeleteAdres = (index, event) => this.pageHelper.deleteAdres(index, event);
    handleConfirmDelete = () => this.pageHelper.confirmDelete();
    handleCancelDelete = () => this.pageHelper.cancelDelete();
    handleConfirmUnknownAdres = () => this.pageHelper.confirmUnknownAdres();
    handleCloseUnknownAdresModal = () => this.pageHelper.closeUnknownAdresModal();

    render() {
        return (
            <div>
                {this.state.deletingAdresId !== null ?
                    <ConfirmModal
                        isOpen={this.state.eletingAdresId !== null}
                        mainText="Weet je zeker dat je dit adres wil verwijderen?"
                        title="Verwijderen adres"
                        confirmAction={this.handleConfirmDelete}
                        confirmText="Ja"
                        cancelText="Nee"
                        cancelAction={this.handleCancelDelete} />
                    : null}
                <AdresForm
                    adressen={this.state.model.adressen}
                    goToNext={this.handleOnGoToNext}
                    goToPrev={this.handleOnGoToPrev}
                    clickAdd={this.handleOnClickAdd}
                    cancelAdd={this.handleOnCancelAdd}
                    addMode={this.state.addMode}
                    editingAdres={this.state.editingAdres}
                    landen={this.props.landen}
                    postcodeGemeenten={this.props.postcodeGemeenten}
                    straten={this.state.straten}
                    huisnummers={this.state.huisnummers}
                    busnummers={this.state.busnummers}
                    adresTypes={this.props.adresTypes}
                    onChange={this.handleOnChange}
                    saveAdd={this.handleOnSaveNewAdres}
                    errors={this.state.errors}
                    onDelete={this.handleOnDeleteAdres}
                    deletingAdresId={this.state.deletingAdresId}
                    showUnknownToPartnerModal={this.state.showUnknownToPartnerModal}
                    confirmUnknownAdres={this.handleConfirmUnknownAdres}
                    closeUnknownAdresModal={this.handleCloseUnknownAdresModal}
                />
            </div>
        );
    }
}

AdresPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        storeModel: state.nieuweSportclubModels.adres,
        landen: state.referentie.landen,
        adresTypes: state.referentie.adresTypes,
        gemeenten: state.referentie.gemeenten,
        postcodeGemeenten: state.referentie.postcodeGemeenten,
        postcodes: state.referentie.postcodes
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadNieuweSportclubAdresPageLayout, dispatch),
        updateModel: bindActionCreators(nieuweSportclubModelsActions.adresModelUpdate, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdresPage);